import React from "react";
import "./styles/DineInBoardToggle.css";

export type DineInBoardView = "tables" | "qr";

interface DineInBoardToggleProps {
  view: DineInBoardView;
  onChange: (view: DineInBoardView) => void;
}

const VIEWS: { id: DineInBoardView; label: string }[] = [
  { id: "tables", label: "Tables" },
  { id: "qr", label: "QR codes" },
];

/**
 * Switches the board between the live floor and the printable-ish QR codes.
 *
 * Only shipped now that the QR side actually does something — a segmented
 * control with a dead half is worse than no control at all.
 */
const DineInBoardToggle: React.FC<DineInBoardToggleProps> = ({ view, onChange }) => (
  <div className="dine-in-toggle" role="tablist" aria-label="Dine-in view">
    {VIEWS.map(({ id, label }) => (
      <button
        key={id}
        type="button"
        role="tab"
        aria-selected={view === id}
        className={`dine-in-toggle__btn ${
          view === id ? "dine-in-toggle__btn--active" : ""
        }`}
        onClick={() => onChange(id)}
      >
        {label}
      </button>
    ))}
  </div>
);

export default DineInBoardToggle;
